// extracted by mini-css-extract-plugin
module.exports = {"share":"shares_share__20R-S","shareOptions":"shares_shareOptions__3GK4y","expired":"shares_expired__2l8ww","expireMessage":"shares_expireMessage__uGqw6"};